import pattern from "./pattern"
// 证件号码
export const validateZjhm = (rule, value, callback, opt) => {
  let regPattern = null
  // 身份证
  if (opt.zjlx === "1") {
    regPattern = pattern.patternIdCard;
  }
  if (value && regPattern !== null && !regPattern.reg.test(value)) {
    callback(new Error(regPattern.msg));
  } else {
    callback();
  }
}
// 富文本
export const validateFwb = (rule, value, callback, opt) => {
  if (value === "<p><br></p>") {
    callback(new Error(opt.msg));
  } else {
    callback();
  }
}

export default {
  validateZjhm,
  validateFwb,
}